import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'menu-button-accessibility',
  templateUrl: './menu-button-accessibility.component.html',
  styleUrls: ['./menu-button-accessibility.component.sass']
})
export class MenuButtonAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
